import { api } from "@/api"

export const requestMagicLink = async (params: {
  tenantIdentifier: string
  email: string
}) => {
  const { body } = await api.post(
    "/auth/web-request-login-link/",
    {
      body: {
        email: params.email,
        merchantId: params.tenantIdentifier,
      },
      headers: {
        "X-DT-SCHEMA": "public",
      },
      authenticated: false,
    }
  )

  return body
}
